import { CartState } from './types'

export const initialState: CartState = {
  items: [],
  isOpen: false,
  scrapPreference: null
}

